import {
  elementaryV2ContentfulMappings,
  middleSchoolV2ContentfulMappings,
  digitalWellBeingV2ContentfulMappings,
  k8V2ContentfulMappings,
} from 'utils/productMaps'
import { countCompleteLessons, countTotalLessons } from 'utils/lmsHelpers'

const PROGRAM_CONTENTFUL_MAPPINGS = {
  elementary: elementaryV2ContentfulMappings,
  'middle-school': middleSchoolV2ContentfulMappings,
  'digital-well-being': digitalWellBeingV2ContentfulMappings,
}

export const getClassInstanceId = classItem =>
  classItem?.instance ??
  (classItem?.registration_id != null ? String(classItem.registration_id) : '')

export const getClassTitle = classItem =>
  classItem?.title ?? classItem?.class_title ?? ''

export const getClassTier = classItem =>
  classItem?.tier ??
  (classItem?.course_name?.toLowerCase()?.includes('tier2') ? 2 : 1)

export const isClassFinished = classItem =>
  classItem?.is_finished === true ||
  classItem?.is_finished === 'true' ||
  classItem?.is_finished === 1

export const getClassTotalLessons = (classItem, courseManager) =>
  classItem?.totalLessons ?? countTotalLessons(classItem, courseManager)

export const getClassCompleteLessons = classItem =>
  classItem?.completeLessons ?? countCompleteLessons(classItem)

const getTier1CourseLinkFromContentfulId = (courseLinks, classItem) =>
  courseLinks?.find(link => classItem?.contentfulID === link?.entryId)

const getCourseLinkForV2Class = ({ classItem, courseLinks, program }) => {
  const courseName = classItem?.course_name
  if (!courseName) return null

  const mappings = PROGRAM_CONTENTFUL_MAPPINGS[program] || []
  const mapping = mappings.find(
    entry =>
      entry?.courseName?.toLowerCase() === String(courseName).toLowerCase(),
  )

  if (!mapping) return null

  return (
    courseLinks?.find(
      link =>
        link?.title === mapping.displayTitle || link?.entryId === mapping.id,
    ) || null
  )
}

const getTier2ContentfulMapping = (classItem, program) => {
  if (classItem?.contentfulID) {
    return (
      k8V2ContentfulMappings?.find(
        course => classItem.contentfulID === course?.id,
      ) || {}
    )
  }

  const mappings =
    PROGRAM_CONTENTFUL_MAPPINGS[program] || k8V2ContentfulMappings
  return (
    mappings.find(
      entry =>
        entry?.courseName?.toLowerCase() ===
        String(classItem?.course_name || '').toLowerCase(),
    ) || {}
  )
}

export const getClassCardDisplayData = ({
  classItem,
  courseLinks,
  tier,
  program,
}) => {
  const courseTier1 =
    tier === 1
      ? getTier1CourseLinkFromContentfulId(courseLinks, classItem) ||
        getCourseLinkForV2Class({ classItem, courseLinks, program })
      : null
  const { displayTitle: tier2DisplayTitle, defaultUnit } =
    tier === 2 ? getTier2ContentfulMapping(classItem, program) : {}

  return {
    courseTier1,
    defaultUnit,
    gradeDisplayTitle: tier === 2 ? tier2DisplayTitle : courseTier1?.title,
  }
}
